<template>
  <SceneFull :type="type" :flag="flag">
    <template v-slot:image>
      <SustainabilitySmall />
    </template>
    <template v-slot:imageFull>
      <SustainabilityBig />
    </template>
  </SceneFull>
</template>

<script>
import { mapState } from "vuex";
import SceneFull from "@/components/SceneFull";
import SustainabilitySmall from "../assets/scenes/sus.svg?inline";
import SustainabilityBig from "../assets/scenes/sus--big.svg?inline";

export default {
  name: "sustainability-scene",

  props: {
    type: String,
    flag: String
  },

  components: {
    SceneFull,
    SustainabilitySmall,
    SustainabilityBig
  }
};
</script>